/**
 * @desc 根据品牌编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductBrandResponseDto>;
export function request(brandNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBrand/byUnique/${brandNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
